import script from "./sf-radio.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-radio.vue?vue&type=script&setup=true&lang=ts"

import "./sf-radio.vue?vue&type=style&index=0&id=ab76afc9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab76afc9"]])

export default __exports__